export var SearchServiceResultGroupType;
(function (SearchServiceResultGroupType) {
    SearchServiceResultGroupType["UNDEFINED"] = "UNDEFINED";
    SearchServiceResultGroupType["HOTEL"] = "HOTEL";
    SearchServiceResultGroupType["CITY"] = "CITY";
    SearchServiceResultGroupType["REGION"] = "REGION";
    SearchServiceResultGroupType["COUNTRY"] = "COUNTRY";
    SearchServiceResultGroupType["SPECIAL_INTEREST"] = "SPECIAL_INTEREST";
})(SearchServiceResultGroupType || (SearchServiceResultGroupType = {}));
export var SearchServiceReferenceType;
(function (SearchServiceReferenceType) {
    SearchServiceReferenceType["HOTEL_CODE"] = "HOTEL_CODE";
    SearchServiceReferenceType["PRODUCT_GROUP"] = "PRODUCT_GROUP";
})(SearchServiceReferenceType || (SearchServiceReferenceType = {}));
